import emailValidator from "email-validator";
export default class EmailService {


  checkEmail(email) {
    return emailValidator.validate(email);
  }

  checkMultipleEmails(emailsToCheck) {
    emailsToCheck = emailsToCheck || '';
    let emails = emailsToCheck.split(",");

    for(var i = 0; i < emails.length; i++) {
      let email = emails[i].trim();
      if(this.checkEmail(email)){
      } else {
        return [false, email];
      }
    }
    return [true];
  }

}
